module.exports = __webpack_public_path__ + "img/ContactInfo.562cc35c.svg";